import { Home } from "../containers";
const home = [{ path: "/", element: <Home /> }];

export default home;
